module.exports = __webpack_public_path__ + "/login_ui/img/cr-5f3a5256cb9eb72e8ed1420d9fa56cc5.svg";